import Marquee from "react-fast-marquee";
import { CONTENT } from "../data/content";

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="border-y border-border py-8 md:py-12 relative overflow-hidden bg-background"
    >
      <div className="marquee-fade">
        <Marquee gradient={false} speed={26} pauseOnHover>
          {CONTENT.marquee.concat(CONTENT.marquee).map((item, i) => (
            <span key={i} className="mx-8 md:mx-12 inline-flex items-center gap-4 md:gap-6">
              <span className="font-heading text-3xl md:text-6xl font-black uppercase tracking-tight text-foreground/80 hover:text-accent transition-colors">
                {item}
              </span>
              <span className="text-accent text-2xl md:text-4xl font-mono">✦</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
